/**
 * Optional per-run options sent with re-analysis requests (M1 contract F).
 *
 * Node persists them on the ledger document (`batch`, `note`, `promote_on_success`). The body
 * field names are the ones the Node controllers read (`batch`, `note`, `promote_on_success`,
 * see videos.controller.ts / manualAnalysis.controller.ts and documentation/docs.json); the
 * JS-side option keeps the camelCase name `promoteOnSuccess`.
 * Only the fields the caller actually set are included, so existing callers are unaffected.
 *
 * @param {{ batch?: string, note?: string, promoteOnSuccess?: boolean }|null|undefined} runOptions
 * @returns {{ batch?: string, note?: string, promote_on_success?: boolean }}
 */
export function buildRunOptionsBody(runOptions) {
  if (!runOptions || typeof runOptions !== 'object') return {};
  const body = {};
  if (typeof runOptions.batch === 'string' && runOptions.batch.trim()) {
    body.batch = runOptions.batch.trim();
  }
  if (typeof runOptions.note === 'string' && runOptions.note.trim()) {
    body.note = runOptions.note.trim();
  }
  if (typeof runOptions.promoteOnSuccess === 'boolean') {
    body.promote_on_success = runOptions.promoteOnSuccess;
  }
  return body;
}

/**
 * Adds the optional `run` query parameter (run id) to a params object when provided.
 * Split endpoints return the active run when it is omitted (M2 reads it from `?run=`).
 *
 * @param {Record<string, unknown>} params
 * @param {string|null|undefined} run
 * @returns {Record<string, unknown>} the same object, for chaining
 */
export function withRunParam(params, run) {
  if (typeof run === 'string' && run.trim()) {
    params.run = run.trim();
  }
  return params;
}
